import Image from "next/image";
import Link from "next/link";

const Footer = () => {


	return (
		<>
			<footer
				className="wow fadeInUp relative z-10 mt-32 bg-saintiantblue pt-16 dark:bg-darkblue md:pt-20 lg:pt-24"
				data-wow-delay=".1s"
			>
				<div className="container">
					<div className="-mx-4 flex flex-wrap">
						<div className="w-full px-4 md:w-1/2 lg:w-4/12 xl:w-5/12">
							<div className="mb-12 max-w-[360px] lg:mb-16">
								<Link href="/" className="mb-8 inline-block">
									<Image
										src="/images/blog/Spandalogo.png"
										alt="logo"
										className="w-full dark:hidden"
										width={140}
										height={30}
									/>
									<Image
										src="/images/logo/logo2.png"
										alt="logo"
										className="hidden w-full dark:block"
										width={140}
										height={30}
									/>
								</Link>
								<p className="mb-9 text-base leading-relaxed text-body-color dark:text-body-color-dark">
									A 206, Kateeleshwari Arcade, Lal Bahadur Shastri Rd, Mulund
									West, Mumbai, Maharashtra 400080 , India
								</p>
								<div className="flex items-center">
									{/*Facebook Component*/}
									<a
										href="https://www.facebook.com/share/1E8oxnC1hy/?mibextid=wwXIfr"
										aria-label="social-link"
										className="mr-6 text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
									>
										<svg
											width="9"
											height="18"
											viewBox="0 0 9 18"
											className="fill-current"
										>
											<path d="M8.13643 7H6.78036H6.29605V6.43548V4.68548V4.12097H6.78036H7.79741C8.06378 4.12097 8.28172 3.89516 8.28172 3.55645V0.564516C8.28172 0.254032 8.088 0 7.79741 0H6.02968C4.11665 0 2.78479 1.58064 2.78479 3.92339V6.37903V6.94355H2.30048H0.65382C0.314802 6.94355 0 7.25403 0 7.70564V9.7379C0 10.1331 0.266371 10.5 0.65382 10.5H2.25205H2.73636V11.0645V16.7379C2.73636 17.1331 3.00273 17.5 3.39018 17.5H5.66644C5.81174 17.5 5.93281 17.4153 6.02968 17.3024C6.12654 17.1895 6.19919 16.9919 6.19919 16.8226V11.0927V10.5282H6.70771H7.79741C8.11222 10.5282 8.35437 10.3024 8.4028 9.96371V9.93548V9.90726L8.74182 7.95968C8.76604 7.7621 8.74182 7.53629 8.59653 7.31048C8.54809 7.16935 8.33016 7.02823 8.13643 7Z" />
										</svg>
									</a>
									{/*Twitter Component*/}
									<a
										href="https://x.com/Spandastetho?s=08"
										aria-label="social-link"
										className="mr-6 text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
									>
										<svg
											width="19"
											height="19"
											viewBox="0 0 30 30"
											className="fill-current"
										>
											<path d="M26.37,26l-8.795-12.822l0.015,0.012L25.52,4h-2.65l-6.46,7.48L11.28,4H4.33l8.211,11.971L12.54,15.97L3.88,26h2.65 l7.182-8.322L19.42,26H26.37z M10.23,6l12.34,18h-2.1L8.12,6H10.23z" />

										</svg>
									</a>
									{/*Youtube Component*/}
									<a
										href="https://www.youtube.com/@SaintiantTech"
										aria-label="social-link"
										className="mr-6 text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
									>
										<svg
											width="18"
											height="14"
											viewBox="0 0 18 14"
											className="fill-current"
										>
											<path d="M17.5058 2.07119C17.3068 1.2488 16.7099 0.609173 15.9423 0.395963C14.5778 7.26191e-08 9.0627 0 9.0627 0C9.0627 0 3.54766 7.26191e-08 2.18311 0.395963C1.41555 0.609173 0.818561 1.2488 0.619565 2.07119C0.25 3.56366 0.25 6.60953 0.25 6.60953C0.25 6.60953 0.25 9.68585 0.619565 11.1479C0.818561 11.9703 1.41555 12.6099 2.18311 12.8231C3.54766 13.2191 9.0627 13.2191 9.0627 13.2191C9.0627 13.2191 14.5778 13.2191 15.9423 12.8231C16.7099 12.6099 17.3068 11.9703 17.5058 11.1479C17.8754 9.68585 17.8754 6.60953 17.8754 6.60953C17.8754 6.60953 17.8754 3.56366 17.5058 2.07119ZM7.30016 9.44218V3.77687L11.8771 6.60953L7.30016 9.44218Z" />
										</svg>
									</a>

									{/*Instagram Component*/}
									<a
										href="https://www.instagram.com/spandastethoscope?igsh=NnpocTRnYTlnaHN0&utm_source=qr"
										aria-label="social-link"
										className="mr-6 text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
									>
										<svg
											width="20"
											height="14"
											viewBox="0 0 24 24"
											className="fill-current"
										>
											<path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />										</svg>
									</a>

								</div>
							</div>
						</div>

						<div className="w-full px-4 sm:w-1/2 md:w-1/2 lg:w-2/12 xl:w-2/12">
							<div className="mb-12 lg:mb-16">
								<h2 className="mb-10 text-xl font-bold text-white dark:text-white">
									Useful Links
								</h2>
								<ul>
									<li>
										<a
											href="/technology"
											className="mb-4 inline-block text-base text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
										>
											Technology
										</a>
									</li>
									<li>
										<a
											href="/usecases"
											className="mb-4 inline-block text-base text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
										>
											Application
										</a>
									</li>
									<li>
										<a
											href="/about"
											className="mb-4 inline-block text-base text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
										>
											About
										</a>
									</li>
								</ul>
							</div>
						</div>

						<div className="w-full px-4 sm:w-1/2 md:w-1/2 lg:w-2/12 xl:w-2/12">
							<div className="mb-12 lg:mb-16">
								<h2 className="mb-10 text-xl font-bold text-white dark:text-white">
									Terms
								</h2>
								<ul>
									<li>
										<a
											href="/warranty"
											className="mb-4 inline-block text-base text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
										>
											Warranty Policy
										</a>
									</li>
									<li>
										<a
											href="/privacy"
											className="mb-4 inline-block text-base text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
										>
											Privacy Policy
										</a>
									</li>
								</ul>
							</div>
						</div>

						<div className="w-full px-4 md:w-1/2 lg:w-4/12 xl:w-3/12">
							<div className="mb-12 lg:mb-16">
								<h2 className="mb-10 text-xl font-bold text-white dark:text-white">
									Support & Help
								</h2>
								<ul>
									<li>
										<a
											href="/contact"
											className="mb-4 inline-block text-base text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
										>
											Contact
										</a>
									</li>
									<li>
										<a
											href="/download"
											className="mb-4 inline-block text-base text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
										>
											Manual
										</a>
									</li>
									<li>
										<a
											href="/faq"
											className="mb-4 inline-block text-base text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
										>
											FAQ
										</a>
									</li>
								</ul>
							</div>
						</div>
											</div>

					<div className="h-px w-full bg-gradient-to-r from-transparent via-[#D2D8E183] to-transparent dark:via-[#959CB183]"></div>
					<div className="py-8">
						<p className="text-center text-base text-body-color dark:text-white">
							<a href="https://www.saintiant.tech/" rel="nofollow noopener">
								saintiant technologies
							</a>
						</p>
					</div>
				</div>
			</footer>
		</>
	);
};

export default Footer;
